export const PROFILE_SETUP_PATH = "/onboarding/profile";

export function needsProfileSetup(user) {
  return Boolean(
    user?.profileSetupRequired &&
    !user?.profileSetupCompletedAt &&
    !user?.profileSetupDismissedAt
  );
}

export function buildProfileSetupPath(locationLike = {}) {
  const pathname = String(locationLike.pathname || "/");
  const search = String(locationLike.search || "");
  const hash = String(locationLike.hash || "");
  const nextPath = pathname.startsWith(PROFILE_SETUP_PATH)
    ? "/"
    : `${pathname}${search}${hash}`;
  return buildProfileSetupPathForNext(nextPath);
}

export function buildProfileSetupPathForNext(nextPath = "/") {
  return `${PROFILE_SETUP_PATH}?next=${encodeURIComponent(nextPath || "/")}`;
}

export function resolvePostAuthPath(user, nextPath = "/") {
  return needsProfileSetup(user)
    ? buildProfileSetupPathForNext(nextPath)
    : nextPath || "/";
}
